const messages = {
  step3: {
    actionBtn: "Prisijungti",
  },
};

export default {
  messages,
};
